import { SvgIcon, SvgIconProps } from '@mui/material'

const PauseCircleOutlineSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18">
        <path
            fill="currentColor"
            d="M9 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2zM1 9a8 8 0 1 1 16 0A8 8 0 0 1 1 9zm6.5-4c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5zm3.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"
        ></path>
    </svg>
)

const PauseCircleOutline: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{PauseCircleOutlineSvg}</SvgIcon>

export default PauseCircleOutline
